import React from 'react'

import {
  string,
  number,
  oneOfType,
  shape,
  oneOf,
} from 'prop-types'

import CircledArrowRight from 'Pods/Shared/Icons/CircledArrowRight'


function CategoryCard({
  title,
  modelsCount = '',
  href = null,
  imageUrl = '',
  imageSources = null,
  shadowType = 'none',
  className = '',
  slug = '',
  productType = '',
}) {
  let containerClassName

  if (shadowType === 'none') {
    containerClassName = 'category-card category-card--no-before'
  } else if (shadowType === 'single') {
    containerClassName = 'category-card'
  } else if (shadowType === 'double') {
    containerClassName = 'category-card category-card--with-shadow'
  } else {
    containerClassName = 'category-card'
  }

  let imageContent = null

  if (imageSources) {
    imageContent = (
      <picture>
        {imageSources.webp && (
          <source srcSet={imageSources.webp} type="image/webp" />
        )}
        {imageSources.jpg && (
          <source srcSet={imageSources.jpg} type="image/jpeg" />
        )}
        <img
          src={imageSources.jpg || imageSources.png || ''}
          alt={title}
          loading="lazy"
          className="category-card__image"
        />
      </picture>
    )
  } else if (imageUrl) {
    imageContent = (
      <img
        src={imageUrl}
        alt={title}
        loading="lazy"
        className="category-card__image"
      />
    )
  }

  const content = (
    <div className="category-card__main">
      {imageContent}
      <div className="category-card__overlay">
        <div className="category-card__info-wrapper">
          <h3 className="cgt-legacy-heading-h6 text-white">{title}</h3>
          {modelsCount !== undefined && modelsCount !== null && (
            <span className="category-card__badge">{modelsCount || 0}</span>
          )}
        </div>
        <div className="category-card__icon-wrapper">
          <CircledArrowRight width="24" height="24" />
        </div>
      </div>
    </div>
  )

  return href ? (
    <a
      className={`${containerClassName} ${className || ''}`}
      href={href}
      data-track="category-click"
      data-category-title={title}
      data-category-slug={slug}
      data-product-type={productType}
      data-content-type="category"
    >
      {content}
    </a>
  ) : (
    <div className={`${containerClassName} ${className || ''}`}>{content}</div>
  )
}

CategoryCard.propTypes = {
  title: string.isRequired,
  modelsCount: oneOfType([string, number]),
  href: string,
  imageUrl: string,
  imageSources: shape({
    webp: string,
    jpg: string,
    png: string,
  }),
  shadowType: oneOf(['none', 'single', 'double']),
  className: string,
  slug: string,
  productType: string,
}

export default CategoryCard
